import { graphql } from "@opensea/graphql"
import { ProfileHeaderCompactContentFragment } from "./ProfileHeaderCompactContent.fragment"
import { ProfileHeaderFullContentFragment } from "./ProfileHeaderFullContent.fragment"
import { ProfileHeaderLayoutGroupFragment } from "./ProfileHeaderLayoutGroup"

export const ProfileHeaderContentFragment = graphql(
  `
    fragment ProfileHeaderContent on Profile {
      ...ProfileHeaderCompactContent
      ...ProfileHeaderFullContent
      ...ProfileHeaderLayoutGroup
    }
  `,
  [
    ProfileHeaderCompactContentFragment,
    ProfileHeaderFullContentFragment,
    ProfileHeaderLayoutGroupFragment,
  ],
)
